import Vue from 'vue'
import RoomDisplay from './RoomDisplay.vue'
import './styles/main.scss'

Vue.config.productionTip = false

Vue.mixin({
  data: function() {
    return {
      showJoinLinks: false,
      playSounds: true
    }
  }
})

new Vue({
  render: h => h(RoomDisplay),
}).$mount('#app')
